import { MonitorInterval } from '@sona/shared-model-common';
import { Duration } from 'date-fns/types';

/**
 * Get the duration for a given monitor interval.
 *
 * @param interval - The monitor interval to get the duration for.
 */
export function getIntervalDuration(interval: MonitorInterval): Duration {
    switch (interval) {
        case 'weekly':
            return { days: 7 };
        case 'monthly':
            return { months: 1 };
        case 'quarterly':
            return { months: 3 };
        case 'yearly':
            return { years: 1 };
        default:
            throw new Error(`Unsupported interval: ${interval}`);
    }
}
